import { useRef, useEffect } from 'react';

/**
 * A hook that returns a stable React ref for a function.
 * The ref will always be kept up to date with the latest
 * version of the callback. Can be used to work around issues
 * with effects that have an incomplete dependency array.
 *
 * Usually it's best to avoid those, but sometimes this is
 * not possible.
 *
 * This function uses a TS overload to make sure that the passed-in
 * callback keeps its type and isn't changed to be potentially
 * undefined.
 * So while the callback parameter should be optional, we don't want
 * that to affect the return type of passed-in functions that are
 * known to be defined.
 *
 * @param {Function} callback - A function
 * @returns a React ref object whose `current` property is set to
 * the latest version of the callback function
 */

function useCallbackRef(callback) {
  var callbackRef = useRef(callback);
  useEffect(function () {
    callbackRef.current = callback;
  }, [callback]);
  return callbackRef;
}
export default useCallbackRef;